<template lang="pug">
div
    RcmTable(
            ref="rcmTable"
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :searchView="searchView"
            :userCanCreate="true"
            :isCreateBtnDisabled="isCreateBtnDisabled"
            :addButtonText="addButtonText"
            primarySearchKey="groupName"
            :primarySearchKeyI18="$t('groupresource.groupName')"
            :userCanIndex="true"
            :rowClassInfo="rowClassInfo"
            :drawerTitleKey="drawerTitleKey"
            :isEditBtnDisabled="!$can('write', 'intelligentProtectionPermission',searchView)"
            :isDeleteBtnDisabled="!$can('write', 'intelligentProtectionPermission',searchView)"
        )
</template>

<script>
import RcmTable from "@/components/RcmTable_v2";
import JsonPoptip from "@/components/JsonPoptip";
import Vue from "vue";
Vue.component("JsonPoptip", JsonPoptip);

import { action, settingZoneExplain, groupName, settingType } from "./fields.js";

export default {
    name: "IntelligentProtectionSettings",
    components: { RcmTable },
    props: { searchView: { type: String, default: "" } },
    data() {
        return {
            esIndex: "rcm-intelligent-protection-settings",
            rowClassInfo: {
                key: "",
                values: [],
                valuesNot: [],
                className: "",
                defaultClassName: "",
            },
            drawerTitleKey: "groupName",
            userCanCreate: true,
            isCreateBtnDisabled: false,
        };
    },
    methods: {
        updateCreateBtnStatus(total) {
            if (this.$store.getters.isAdmin && this.$store.state.queryGroupName == "all") return;
            this.isCreateBtnDisabled = total > 0;
        },
    },
    computed: {
        esIndexFields() {
            return {
                action: action(this),
                settingZoneExplain: settingZoneExplain(this),
                groupName: groupName(this),
                settingType: settingType(this),
                _id: {},
                wafRuleList: {},
                createBy: {},
                createdDate: {},
                modifiedDate: {},
            };
        },
        addButtonText() {
            return this.$i18n.t("intelligentProtectionSettings.addButtonText");
        },
    },
    mounted() {
        this.$watch(
            () => this.$refs.rcmTable && this.$refs.rcmTable.tableDataTotal,
            (newVal) => {
                this.updateCreateBtnStatus(newVal);
            }
        );
    },
};
</script>



// WEBPACK FOOTER //
// src/view/IntelligentProtectionSettings/Page.vue